export const LOGIN_MUTATION = `
  mutation LoginMutation($input: loginUserInput!) {
    public {
      login(input: $input) {
        token
      }
    }
  }
`;
